import Text from 'components/Text/Text';
import React from 'react';
import { Switch } from 'antd';
import classNames from 'classnames';
import style from './FreeDevicesSwitch.module.scss';

interface IFreeDevicesSwitch {
	showFreeDevices: boolean;
	toggleSetShowFreeDevices: () => void;
}

const FreeDevicesSwitch: React.FC<IFreeDevicesSwitch> = ({ showFreeDevices, toggleSetShowFreeDevices }) => {
	const switchElementClass = classNames({ [style.switchActive]: showFreeDevices });

	return (
		<div className={style.container}>
			<Switch className={switchElementClass} checked={showFreeDevices} onChange={toggleSetShowFreeDevices} />
			<Text
				className={style.switchLabel}
				translationNameSpace="form"
				translationKey="freeDevicesLabel"
				weight="thin"
				display="inline"
			/>
		</div>
	);
};

export default React.memo(FreeDevicesSwitch);
